import { buildProps } from '@vuesax-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Checkbox from './checkbox.vue'

export const checkboxProps = buildProps({})

export type CheckboxProps = ExtractPropTypes<typeof checkboxProps>
export type CheckboxInstance = InstanceType<typeof Checkbox>
